import React, { useEffect } from "react";
import { useSelector } from "react-redux";

// ThemeProvider component to manage and apply the theme based on the Redux state
export function ThemeProvider({ children }) {
  // Access the nightMode state from the Redux store
  const nightMode = useSelector((state) => state.theme.nightMode);

  // useEffect hook to apply the theme whenever the nightMode state changes
  useEffect(() => {
    const theme = nightMode ? "dark" : "light"; // Determine the theme based on nightMode
    document.documentElement.setAttribute("data-bs-theme", theme); // Set the theme attribute on the root HTML element
    localStorage.setItem("theme", theme); // Save the theme preference in localStorage
  }, [nightMode]); // Dependency array ensures this effect runs whenever nightMode changes

  // Render the children wrapped by this provider
  return <>{children}</>;
}
